import Header from "./Header";
import Footer from "./Footer";
import OfflineBanner from "./OfflineBanner";

export default function Layout({ children }) {
  return (
    <>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" className="app-main" tabIndex={-1}>
        <div className="container">
          <OfflineBanner />
          {children}
        </div>
      </main>
      <Footer />
    </>
  );
}
